// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_gd-0";